var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgJobsIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 64,
  height: 64,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 64,
  height: 64,
  fill: "#FFF7CB",
  rx: 32
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#656565",
  d: "M26.731 23.58h-1.688V21.1c0-1.153.947-2.1 2.108-2.1h9.707c1.16 0 2.097.947 2.097 2.1v2.264h-1.687V21.1a.417.417 0 0 0-.42-.42h-9.707a.417.417 0 0 0-.42.42v2.48z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#F3A900",
  d: "M24.146 22.68h3.473c.215 0 .39.176.39.391v.976h-4.253v-.976c0-.215.175-.39.39-.39M36.371 22.68h3.473c.215 0 .39.176.39.391v.976h-4.253v-.976c0-.215.175-.39.39-.39"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#656565",
  d: "M47.19 25.063v19.098a.84.84 0 0 1-.84.84H17.659a.84.84 0 0 1-.839-.84V25.063c0-.693.566-1.26 1.259-1.26h27.844a1.27 1.27 0 0 1 1.268 1.26"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#292929",
  d: "M47.376 31.195 32 35.227l-15.376-4.032a.835.835 0 0 1-.624-.81v-5.742c0-.468.38-.84.839-.84h30.322a.84.84 0 0 1 .839.84v5.732c0 .38-.254.722-.624.82"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFE040",
  d: "M30.332 32.708h3.346c.215 0 .39.175.39.39v4.745c0 .215-.175.39-.39.39h-3.346a.39.39 0 0 1-.39-.39v-4.745c0-.215.165-.39.39-.39"
})));
export default SvgJobsIcon;